export enum FUNCTION_TYPE {
  EXPRESSION_CALCULATION = 'expressionFunction',
  FOR_LOOP = 'forLoop',
  SET_INTERVAL = 'setIntervalFunction',
  CLEAR_INTERVAL = 'clearIntervalFunction'
}

export enum PARAMETER_VALUE_TYPE {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  Array = 'array',
  Object = 'object',
  Function = 'function'
}

export enum PARAMETER_TYPE {
  FIXED = 'fixed',//固定参数
  DYNAMIC = 'dynamic',//动态参数
  ATTRIBUTE = 'attribute',//组件属性
  CSS_ATTRIBUTE = 'css_attribute',//组件样式属性
  CUSTOM_FUNCTION = 'custom_function',//自定义函数参数
  STANDARD_FUNCTION = 'standard_function',//标准函数
  ELEMENT_FUNCTION = 'element_function',//dom函数
  ROUTE_FUNCTION = 'route_function',//路由函数
  MATHS_FUNCTION = 'maths_function',//数学函数
  OPERATOR = 'operator',//操作符
  LOGIC = 'logic',//逻辑连接符
  PRIORITY = 'priority',//括号
  API_INFO = 'apiInfo',//api信息
  MENU = 'menu',//菜单信息
  DATA_SOURCE = 'dataSource',//数据源信息
  ASSIGNMENT = 'assignment'//赋值符号
}

export enum DYNAMIC_PARAMETER {
  CURRENT_PROP = 'currentProp'
}

export const FUNCTION_LIST = [
  {
    name: 'getComponent',
    label: '获取组件定义',
    params: [
      {
        label: '组件唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'prop'
      }
    ]
  },
  {
    name: 'getAttr',
    label: '获取属性值',
    params: [
      {
        label: '组件唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'prop'
      },
      {
        label: '属性名',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'attr'
      }
    ]
  },
  {
    name: 'getCssAttr',
    label: '获取样式属性',
    params: [
      {
        label: '组件唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'prop'
      },
      {
        label: '属性名',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'attr'
      }
    ]
  },
  {
    name: 'setAttr',
    label: '设置属性值',
    params: [
      {
        label: '组件唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'prop'
      },
      {
        label: '属性值',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'attr'
      },
      {
        label: '属性值',
        value: 'value'
      }
    ]
  },
  {
    name: 'setCssAttr',
    label: '设置样式属性',
    params: [
      {
        label: '组件唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'prop'
      },
      {
        label: '属性名',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'attr'
      },
      {
        label: '属性值',
        value: 'value'
      }
    ]
  },
  {
    name: 'setStandardCssAttr',
    label: '设置标准样式属性',
    params: [
      {
        label: '组件唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'prop'
      },
      {
        label: '属性名',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'attr'
      },
      {
        label: '属性值',
        value: 'value'
      }
    ]
  },
  {
    name: 'getFrequency',
    label: '获取循环区域循环次数',
    params: [
      {
        label: '循环区域唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'cyclicRegionProp'
      }
    ]
  },
  {
    name: 'moveCyclicRegion',
    label: '循环区域平移',
    params: [
      {
        label: '循环区域唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'cyclicRegionProp'
      },
      {
        label: '平移方向',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'direction'
      },
      {
        label: '平移步长',
        valueType: PARAMETER_VALUE_TYPE.Number,
        value: 'step'
      }
    ]
  },
  {
    name: 'expressionFunction',
    label: '表达式计算',
    params: [
      {
        label: '表达式入参',
        valueType: PARAMETER_VALUE_TYPE.String,
        restParameter: true,//可变参数标识
      }
    ],
  },
  {
    name: 'forLoop',
    label: 'for循环',
    params: [
      {
        label: '循环体',
        valueType: PARAMETER_VALUE_TYPE.Function,
        value: 'loopBody'
      },
      {
        label: '循环次数',
        valueType: PARAMETER_VALUE_TYPE.Number,
        value: 'loopCount'
      }
    ]
  },
  {
    name: 'setInterval',
    label: '设置定时器',
    params: [
      {
        label: '定时器回调函数',
        valueType: PARAMETER_VALUE_TYPE.Function,
        value: 'callback'
      },
      {
        label: '定时器间隔',
        valueType: PARAMETER_VALUE_TYPE.Number,
        value: 'interval'
      }
    ]
  },
  {
    name: 'clearInterval',
    label: '销毁定时器',
    params: [
      {
        label: '定时器标识',
        valueType: PARAMETER_VALUE_TYPE.Number,
        value: 'timerId'
      }
    ]
  },
  {
    name: 'lodashGet',
    label: 'lodash-get函数',
    params: [
      {
        label: '目标对象',
        valueType: PARAMETER_VALUE_TYPE.Object,
        value: 'data'
      },
      {
        label: '目标索引',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'key'
      }
    ]
  },
  {
    name: 'skeletonScreen',
    label: '骨架屏函数',
    params: [
      {
        label: '循环区域唯一标识',
        valueType: PARAMETER_VALUE_TYPE.String,
        value: 'cyclicRegionProp'
      }
    ]
  }
];

export enum DYNAMIC_PARAMETER_TYPE {
  CURRENT_PROP = 'currentProp',
  CURRENT_COMPONENT = 'currentComponent',
  CURRENT_INDEX = 'currentIndex',
  CURRENT_ITEM = 'currentItem',
  FUNCTION_PARAMETER = 'functionParameter',
  EVENT = 'event'
}
